// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__GOECZ","logo__img":"Logo_logo__img__fb5z8"};